const DEFAULT_DURATION = 2500

const TRANSIENT_TYPES = ['success', 'info']

const state = {
  notifications: [],
}

const getters = {
  notifications: (state) => state.notifications,
}

const mutations = {
  push(state, data) {
    data.position = data.position || 'right-top'
    data.id = Date.now()
    state.notifications.push(data)

    data.timerId = setTimeout(() => {
      state.notifications = state.notifications.filter((n) => n.id !== data.id)
    }, data.time || DEFAULT_DURATION)
  },

  clearTimer(state, id) {
    const notification = state.notifications.find((n) => n.id === id)
    if (!notification) return
    
    clearTimeout(notification.timerId)
    notification.timerId = null
  },

  startTimer(state, id) {
    const notification = state.notifications.find((n) => n.id === id)
    if (!notification) return

    notification.timerId = setTimeout(() => {
      state.notifications = state.notifications.filter((n) => n.id !== id)
    }, notification.time || DEFAULT_DURATION)
  },

  removeItem(state, id) {
    const index = state.notifications.findIndex((n) => n.id === id)
    if (index !== -1) {
      clearTimeout(state.notifications[index].timerId)
      state.notifications.splice(index, 1)
    }
  },

  clearTransient(state) {
    const isTransient = (n) => TRANSIENT_TYPES.includes(n.type)
    state.notifications.filter(isTransient).forEach((n) => clearTimeout(n.timerId))
    state.notifications = state.notifications.filter((n) => !isTransient(n))
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
